/**
 * Export `uid`
 */

module.exports = uid;

/**
 * Create a `uid`
 *
 * @param {String} len
 * @return {String} uid
 */

function uid(len) {
  len = len || 7;
  return Math.random().toString(35).substr(2, len);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/uid/index.js
// module id = 63
// module chunks = 0